function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '',
        active = swatches.querySelector('.product-card-swatch.active');

      swatch_list.forEach((swatch, index) => {

        swatch.addEventListener('mouseover', function () {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }

          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}
/**
 *  @class
 *  @function Header
 */
class Header {
  constructor() {
    const header = document.querySelector('.header-section'),
      header_main = document.getElementById('header'),
      menu = document.getElementById('mobile-menu'),
      toggle = document.querySelector('.mobile-toggle-wrapper'),
      setHeaderOffset = this.setHeaderOffset,
      setAnnouncementHeight = this.setAnnouncementHeight,
      setHeaderHeight = this.setHeaderHeight;

    if (!header_main) {
      return;
    }
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          toggle.removeAttribute('open');
          toggle.classList.remove('active');
        }
      }
    });
    toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
      setAnnouncementHeight(header);
      if (toggle.classList.contains('active')) {
        e.preventDefault();
        document.body.classList.remove('overflow-hidden');
        toggle.classList.remove('active');
        this.closeAnimation(toggle);

      } else {
        document.body.classList.add('overflow-hidden');
        setTimeout(() => {
          toggle.classList.add('active');
        });
      }
      window.dispatchEvent(new Event('resize.resize-select'));
    });

    // Mobile Menu offset
    window.addEventListener('scroll', function () {
      setHeaderOffset(header);
      setHeaderHeight(header_main);
      // Sticky Header Class
      if (header_main.classList.contains('header-sticky--active')) {
        let offset = parseInt(header_main.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;

        header_main.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }

    }, {
      passive: true
    });
    window.dispatchEvent(new Event('scroll'));

    if (document.getElementById('shopify-section-announcement-bar')) {
      const a_bar = document.getElementById('shopify-section-announcement-bar');
      window.addEventListener('resize', function () {
        setAnnouncementHeight(a_bar);
      }, {
        passive: true
      });
      window.dispatchEvent(new Event('resize'));
    }
    // Buttons.
    menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    menu.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }
  setAnnouncementHeight(a_bar) {
    let h = a_bar.clientHeight;
    document.documentElement.style.setProperty('--announcement-height', h + 'px');
  }
  setHeaderOffset(header) {
    let h = header.getBoundingClientRect().top;
    document.documentElement.style.setProperty('--header-offset', h + 'px');
  }
  setHeaderHeight(header) {
    let h = header.clientHeight;
    document.documentElement.style.setProperty('--header-height', h + 'px');
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.link-container');
    const isOpen = detailsElement.hasAttribute('open');

    setTimeout(() => {
      detailsElement.classList.add('menu-opening');
      parentMenuElement && parentMenuElement.classList.add('submenu-open');
    }, 100);
  }
  onCloseButtonClick(event) {
    event.preventDefault();
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        detailsElement.querySelectorAll('details').forEach((details) => {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
          details.classList.remove('submenu-open');
        });
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener('resize', debounce(function () {
        _this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    constructor() {
      super();
      let cc = document.querySelector('.click-capture');

      // Add functionality to buttons
      this.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener('click', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer')) {
        this.close_quick_view(panel);
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view(panel) {
      panel = panel ? panel : document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {

  constructor() {
    this.container = document.getElementById('Cart-Drawer');

    if (!this.container) {
      return;
    }
    let _this = this,
      button = document.getElementById('cart-drawer-toggle'),
      quantities = this.container.querySelectorAll('.quantity input');


    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        this.container.classList.add('active');
        this.container.focus();
        setTimeout(() => {
          if (this.container.querySelector('.product-recommendations--full')) {
            this.container.querySelector('.product-recommendations--full').classList.add('active');
          }
        });
        dispatchCustomEvent('cart-drawer:open');
      });
    }

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.removeProductEvent();
    this.updateFreeShipping();
    // Terms checkbox
    this.termsCheckbox();
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartDrawerTerms'),
      checkout_button = this.container.querySelector('.button.checkout');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }
  updateFreeShipping() {
    const free_shipping = this.container.querySelector('.free-shipping');

    if (free_shipping) {
      let amount_text = free_shipping.querySelector('.free-shipping--text span');
      let total = parseInt(free_shipping.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(free_shipping.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;

      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
      }

      free_shipping.style.setProperty('--percentage', percentage);
    }
  }
  updateQuantity(line, quantity) {
    this.container.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    if (this.container.querySelector('.product-recommendations--full')) {
      this.container.querySelector('.product-recommendations--full').classList.remove('active');
    }
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        this.updateFreeShipping();
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });

        if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
        if(typeof trigger_messages == 'function'){
            trigger_messages();
        }
      });
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.hide();
      }
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-localization-forms').forEach((localization) => {
      localization.addEventListener('change', (e) => {
        localization.querySelector('form').submit();
      });
    });
  }
}



/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container').classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.sidePanel = this.closest('.side-panel')
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });

      const btn = this.buttons[i]

      if (btn) {
        btn.classList.add('tab-active');
      }
      this._updateSidepanelAttrsFromBtn(btn);

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });

      const panel = this.panels[i]
      if (panel) {
        this.panels[i].classList.add('tab-active');
      }
    }

    _updateSidepanelAttrsFromBtn(btn) {
      if (this.sidePanel) {
        const tabName = !btn ? '' : btn.getAttribute('data-tab-name') || ''
        const tabId = !btn ? '' : btn.getAttribute('data-tab-id') || ''

        this.sidePanel.setAttribute('data-active-panel-name', tabName);
        this.sidePanel.setAttribute('data-active-panel-id', tabId);
      }
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        setTimeout(() => {
          this.prepareAnimations();
          this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
        }, 400);
      }
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector('summary').offsetHeight,
        content_height = this.querySelector('.collapsible__content').offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height;

      this.tl = false;
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: 'sine.inOut',
        onStart: function () {
          _this.details.open = true;
          _this.details.style.overflow = 'hidden';
        },
        onReverseComplete: function () {
          _this.details.open = false;
          _this.details.style.overflow = '';
        }
      });

      this.tl
        .fromTo(_this.details, {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24);
            return h;
          },
          clearProps: 'height'
        }, {
          duration: 0.6,
          height: final_height,
          clearProps: 'height'
        });

      if (this.details.open) {
        this.tl.progress(1);
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      e.preventDefault();
      if (this.tl.reversed()) {
        this.tl.timeScale(1).play();
      } else {
        this.tl.timeScale(3).reverse();
      }
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}
/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;

      if (!handle) {
        return;
      }
    }
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof (recentIds) !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {

  if (typeof Localization !== 'undefined') {
    new Localization();
  }
  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer();
  }
  if (typeof Header !== 'undefined') {
    new Header();
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});





// ----------------------------------------------------------------------------

/* Stamped scroll into view */
(function() {
  function domReady(cb) {
    if (document.readyState !== 'loading') {
      cb();
    } else {
      document.addEventListener('DOMContentLoaded', cb);
    }
  }

  const stampedBadges = Array.from(document.querySelectorAll('.product-information product-rating-badge[pid][goto="scroll"]:not([data-scroll-listening])'))

  stampedBadges.reduce((list, el) => {
    const pid = el.getAttribute('data-product-id') || el.getAttribute('pid')
    if (!pid) return list
    el.setAttribute('data-scroll-listening', '')

    // const stampedReviewsSelector = `.stamped-main-widget[data-product-id="${pid}"]`
    const stampedReviewsSelector = `.yotpo-widget-instance[data-yotpo-product-id="${pid}"]`
    const stamped = document.querySelector(stampedReviewsSelector);
    if (!stamped) return list


    const parentAccordion = stamped.closest('.tabbed-content--content')
    if (!parentAccordion) return list

    list.push({
      trigger: el,
      destination: stamped,
      accordion: parentAccordion,
      accordionTrigger: parentAccordion.parentElement.querySelector('.tabbed-content--tabs [data-review-trigger="true"]'),
      mainWidget: stamped,
    })

    return list
  }, [])
  .forEach(onClick_RatingBadge)

  function onClick_RatingBadge(item) {
    item.trigger.addEventListener('click', async e => {
      e.preventDefault()
      e.stopPropagation()

      const isOpened = item.accordion.classList.contains('active')
      if (!isOpened) {
        item.accordionTrigger.click()
        await new Promise(res => setTimeout(res, 250))
        setTimeout(() => {
          item.accordionTrigger.scrollIntoView()
        }, 500)
      }

      if (StampedScrollToMainWidget) {
        StampedScrollToMainWidget(item.mainWidget);
      }
    })
  }

  function StampedScrollToMainWidget(mainWidget, duration) {
    if (!mainWidget) { return }
    let desktopOffset = mainWidget.getAttribute('data-offset') || 1
    let mobileOffset = mainWidget.getAttribute('data-offset-mobile') || 1
    let _duration =
      duration || mainWidget.getAttribute('data-animation-duration')
    let offset = isMobile() ? Number(mobileOffset) : Number(desktopOffset)

    document.documentElement.style.scrollBehavior = 'initial'
    animateScrollTo(
      absoluteOffset(mainWidget).top - offset,
      _duration || 700,
    )
  }

  // window.StampedScrollToMainWidget = StampedScrollToMainWidget

  function isMobile() {
    return window.innerWidth < 768
  }

  function absoluteOffset(element) {
    let rect = element.getBoundingClientRect()
    return { top: rect.top + window.scrollY, left: rect.left + window.scrollX }
  }

  // t = current time
  // b = start value
  // c = change in value
  // d = duration
  function easeInOutQuad(t, b, c, d) {
    t /= d / 2
    if (t < 1) return (c / 2) * t * t + b
    t--
    return (-c / 2) * (t * (t - 2) - 1) + b
  }

  let isAnimating = false
  let events = [
    'scroll',
    'mousedown',
    'wheel',
    'DOMMouseScroll',
    'mousewheel',
    'keyup',
    'touchmove',
  ]

  function stopAnimationFn() {
    isAnimating = false
  }

  function animateScrollTo(to, duration) {
    const doc = document.scrollingElement || document.documentElement
    const start = doc.scrollTop
    const change = to - start
    const startDate = +new Date()

    isAnimating = true
    events.forEach(event => {
      document.documentElement.addEventListener(event, stopAnimationFn)
    })

    function animateScroll() {
      if (!isAnimating) return

      const currentDate = +new Date()
      const currentTime = currentDate - startDate
      doc.scrollTop = parseInt(
        easeInOutQuad(currentTime, start, change, duration),
      )
      if (currentTime < duration) {
        requestAnimationFrame(animateScroll)
      } else {
        doc.scrollTop = to
        isAnimating = false
        document.documentElement.style.scrollBehavior = ''

        events.forEach(event => {
          document.documentElement.removeEventListener(event, stopAnimationFn)
        })
      }
    }

    animateScroll()
  }

  document.querySelector('.product-information a.star-rating-container')?.addEventListener('click', e => {
    e.preventDefault()
    const btn = document.querySelector('[data-review-trigger="true"]')
    if (btn) { btn.click(); btn.scrollIntoView({ behavior: 'smooth' }) }
  })

  if (location.hash == '#shopify-block-yotpo-reviews-widget') {
    window.addEventListener('wnw_load', () => {
      setTimeout(() => {
        stampedBadges[0] && stampedBadges[0].dispatchEvent(new Event('click'))
        // remove hash
        history.replaceState({}, document.title, window.location.pathname + window.location.search)
      }, 1000)
    })
  }
})();

// ----------------------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function() {
    const wrapper = document.querySelector('.fs-subnav-wrapper');
    const subnavLinks = document.querySelectorAll('.fs-subnav-link');

    // Detect if the user is on a touch device
    const isTouchDevice = ('ontouchstart' in window || navigator.maxTouchPoints > 0);

    // 1. TELEPORT HACK: Move the dropdowns OUT of the scrolling area on mobile/tablet
    if (window.innerWidth <= 1024) {
        document.querySelectorAll('.fs-subnav-item').forEach(function(item, index) {
            const dropdown = item.querySelector('.fs-subnav-dropdown');
            if (dropdown) {
                const menuId = 'fs-mobile-menu-' + index;
                item.setAttribute('data-target-menu', menuId);
                dropdown.setAttribute('id', menuId);
                wrapper.appendChild(dropdown);
            }
        });
    }

    // 2. The Button Click Logic
    subnavLinks.forEach(function(link) {
        link.setAttribute('onclick', 'void(0)'); // Safari tap hack

        link.addEventListener('click', function(e) {
            const parentItem = this.closest('.fs-subnav-item');

            // --- MOBILE & TABLET BEHAVIOR (1024px and smaller) ---
            if (window.innerWidth <= 1024) {
                const menuId = parentItem.getAttribute('data-target-menu');
                
                if (menuId) {
                    const dropdown = document.getElementById(menuId);

                    if (dropdown) {
                        e.preventDefault();
                        e.stopPropagation();

                        const isOpen = (dropdown.style.display === 'block');

                        // Close all menus first
                        document.querySelectorAll('.fs-subnav-dropdown').forEach(function(menu) {
                            menu.style.display = 'none';
                        });
                        document.querySelectorAll('.fs-subnav-item').forEach(function(item) {
                            item.classList.remove('is-open');
                            item.querySelector('.fs-subnav-link').style.backgroundColor = '';
                        });

                        // If it was closed, open it
                        if (!isOpen) {
                            dropdown.style.display = 'block';
                            parentItem.classList.add('is-open');
                            this.style.backgroundColor = '#f0ebd4'; 
                        }
                    }
                }
            } 
            
            // --- LARGE PRO TABLET BEHAVIOR (Larger than 1024px, but has a touch screen) ---
            else if (isTouchDevice) {
                const dropdown = parentItem.querySelector('.fs-subnav-dropdown');
                
                if (dropdown) {
                    e.preventDefault(); 
                    // Lets Apple's native iOS engine apply the :hover state safely
                }
            }
        });
    });

    // 2b. Handle clicks on 2nd tier items with children (tier 3)
    document.querySelectorAll('.fs-subnav-dropdown li.menu-item-has-children > a').forEach(function(link) {
        link.addEventListener('click', function(e) {
            // Only on mobile/tablet
            if (window.innerWidth <= 768) {
                const parentLi = this.parentElement;
                const isOpen = parentLi.classList.contains('is-open');

                if (!isOpen) {
                    // First click: prevent navigation and open tier 3
                    e.preventDefault();
                    e.stopPropagation();

                    // Close all other tier 3 items
                    document.querySelectorAll('.fs-subnav-dropdown li.menu-item-has-children').forEach(function(item) {
                        item.classList.remove('is-open');
                    });

                    // Open this tier 3
                    parentLi.classList.add('is-open');
                } else {
                    // Second click: allow navigation (don't prevent default)
                }
            }
        });
    });

    // 3. Close when tapping outside (Mobile/Tablet)
    document.addEventListener('click', function(e) {
        if (window.innerWidth <= 1024 && !e.target.closest('.fs-subnav-wrapper')) {
            document.querySelectorAll('.fs-subnav-dropdown').forEach(function(menu) {
                menu.style.display = 'none';
            });
            document.querySelectorAll('.fs-subnav-item').forEach(function(item) {
                item.classList.remove('is-open');
                item.querySelector('.fs-subnav-link').style.backgroundColor = '';
            });
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    // 1. Agar URL me UTMs hain, toh unhe Browser ki Session Storage me save kar lo
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('utm_source') || urlParams.has('utm_medium') || urlParams.has('utm_campaign')) {
        if(urlParams.get('utm_source')) sessionStorage.setItem('sh_utm_source', urlParams.get('utm_source'));
        if(urlParams.get('utm_medium')) sessionStorage.setItem('sh_utm_medium', urlParams.get('utm_medium'));
        if(urlParams.get('utm_campaign')) sessionStorage.setItem('sh_utm_campaign', urlParams.get('utm_campaign'));
    }

    // 2. Footer me newsletter button ko dhundho
    var newsletterLinks = document.querySelectorAll('.signup-container a'); 

    if (newsletterLinks.length > 0) {
        // URL ki jagah ab hum 'Session Storage' se data uthayenge (taaki user kisi bhi page par ho, data mil jaye)
        var source = sessionStorage.getItem('sh_utm_source');
        var medium = sessionStorage.getItem('sh_utm_medium');
        var campaign = sessionStorage.getItem('sh_utm_campaign');
        
        newsletterLinks.forEach(function(link) {
            var originalHref = link.href;
            var separator = originalHref.indexOf('?') !== -1 ? '&' : '?'; 
            
            if (source) {
                // Agar Ad se aaya hai (kisi bhi pichle page par)
                link.href = originalHref + separator + 'utm_source=' + encodeURIComponent(source);
                if (medium) link.href += '&utm_medium=' + encodeURIComponent(medium);
                if (campaign) link.href += '&utm_campaign=' + encodeURIComponent(campaign);
            } else {
                // Agar sach me Direct/Organic traffic hai
                link.href = originalHref + separator + 'utm_source=shopify_footer';
            }
        });
    }
});

// F&S Unified Identity Tracker for Shopify (with Database Sync & Smart UTM Preservation)
console.log("FS Tracker: Script successfully loaded in browser.");

function initFSTracker() {
    const COOKIE_NAME = 'fs_customer_id';
    const COOKIE_DOMAIN = '.fieldandstream.com'; 
    const WP_SYNC_URL = 'https://fieldandstream.com/wp-admin/admin-ajax.php';
    
    window.dataLayer = window.dataLayer || [];

    // --- Helpers ---
    async function hashEmail(email) {
        const normalized = email.toLowerCase().trim();
        const msgUint8 = new TextEncoder().encode(normalized);
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    }

    function setIdentityCookie(hash) {
        if (!hash) return;
        const d = new Date();
        d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = `${COOKIE_NAME}=${hash}; ${expires}; domain=${COOKIE_DOMAIN}; path=/; SameSite=Lax; Secure`;
    }

    function getIdentityCookie() {
        const name = COOKIE_NAME + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return null;
    }

    function pushToDataLayer(customerId, source = 'cookie_load') {
        if (window.fsIdentityPushed) return;
        window.dataLayer.push({
            'event': 'fs_identity_resolved',
            'fs_customer_id': customerId,
            'identity_source': source
        });
        window.fsIdentityPushed = true;
    }

    // --- Background Database Sync (Zero Page Speed Impact) ---
    function syncIdentityToBackend(hash, rawEmail = '', sourceType = 'shopify_event', formId = '') {
        if (!hash) return;
        try {
            const params = new URLSearchParams();
            params.append('action', 'fs_log_client_identity');
            params.append('hash', hash);
            if (rawEmail) params.append('email', rawEmail);
            if (sourceType) params.append('source_type', sourceType);
            if (formId) params.append('form_id', formId);
            params.append('source_url', window.location.href);

            if (window.shopifyCustomerId) {
                params.append('shopify_customer_id', window.shopifyCustomerId);
            }

            // Background sendBeacon (non-blocking)
            if (navigator.sendBeacon) {
                navigator.sendBeacon(WP_SYNC_URL, params);
            } else {
                fetch(WP_SYNC_URL, {
                    method: 'POST',
                    body: params,
                    keepalive: true,
                    mode: 'cors'
                }).catch(function() {});
            }
        } catch(e) {
            // Failsafe silent catch
        }
    }

    // --- Core Logic ---

    // 1. Process Shopify Logged-in Customer
    if (window.shopifyCustomerHash && window.shopifyCustomerHash !== 'null' && window.shopifyCustomerHash !== '') {
        setIdentityCookie(window.shopifyCustomerHash);
        
        // Sync to WP Database only once per session to avoid repeated DB calls
        const sessionKey = 'fs_db_synced_' + window.shopifyCustomerHash;
        if (!sessionStorage.getItem(sessionKey)) {
            syncIdentityToBackend(
                window.shopifyCustomerHash, 
                window.shopifyCustomerEmail || '', 
                'shopify_account_login', 
                'customer_account'
            );
            sessionStorage.setItem(sessionKey, '1');
        }
    }

    // 2. Smart URL "Auto-Eraser" (Extracts _eid, preserves 100% of UTM parameters)
    function processUrlIdentity() {
        let rawEmail = null;
        const searchParams = new URLSearchParams(window.location.search);
        const hash = window.location.hash;

        // A. Check if _eid is in standard query string (?_eid=...)
        if (searchParams.has('_eid')) {
            rawEmail = searchParams.get('_eid');
            searchParams.delete('_eid');
        }

        // B. Check if _eid is in hash fragment (#_eid=...)
        let remainingHash = '';
        if (hash.includes('_eid')) {
            let frag = hash.substring(1);
            
            // Rescue any UTM parameters trapped after the hash (e.g. #_eid=email?utm_source=...)
            if (frag.includes('?')) {
                const parts = frag.split('?');
                frag = parts[0];
                const trappedParams = new URLSearchParams(parts[1]);
                trappedParams.forEach((val, key) => {
                    if (!searchParams.has(key)) {
                        searchParams.set(key, val);
                    }
                });
            }

            const hashParams = new URLSearchParams(frag);
            if (hashParams.has('_eid')) {
                if (!rawEmail) rawEmail = hashParams.get('_eid');
                hashParams.delete('_eid');
            }
            const cleanFragStr = hashParams.toString();
            remainingHash = cleanFragStr ? '#' + cleanFragStr : '';
        } else if (hash) {
            remainingHash = hash;
        }

        // C. Reconstruct clean URL keeping 100% of UTMs and removing ONLY _eid
        const cleanSearch = searchParams.toString();
        const cleanUrl = window.location.pathname + (cleanSearch ? '?' + cleanSearch : '') + remainingHash;

        if (cleanUrl !== (window.location.pathname + window.location.search + window.location.hash)) {
            window.history.replaceState(null, '', cleanUrl);
        }

        if (rawEmail) {
            rawEmail = rawEmail.trim();
            hashEmail(rawEmail).then(hash => {
                setIdentityCookie(hash);
                pushToDataLayer(hash, 'shopify_email_link_click');
                syncIdentityToBackend(hash, rawEmail, 'email_link_click', 'url_identity');
            }).catch(err => console.error("FS Tracker: Hashing Error", err));
        }
    }

    processUrlIdentity();

    // 3. Initial Page Load Push
    const existingCookie = getIdentityCookie();
    if (existingCookie) {
        pushToDataLayer(existingCookie);
    }

    // 4. Form Submission Listeners
    document.body.addEventListener('submit', async function(e) {
        const emailInput = e.target.querySelector('input[type="email"], input[name*="email"]');
        if (emailInput && emailInput.value) {
            const rawEmail = emailInput.value;
            const hash = await hashEmail(rawEmail);
            setIdentityCookie(hash);
            pushToDataLayer(hash, 'shopify_form_submission');
            syncIdentityToBackend(hash, rawEmail, 'shopify_form_submission', e.target.id || 'form');
        }
    });

    document.body.addEventListener('click', async function(e) {
        const btn = e.target.closest('button[type="submit"], input[type="submit"], button[name="subscribe"]');
        if (btn) {
            const formWrapper = btn.closest('form') || btn.closest('div');
            if (formWrapper) {
                const emailInput = formWrapper.querySelector('input[type="email"], input[name*="email"]');
                if (emailInput && emailInput.value) {
                    const rawEmail = emailInput.value;
                    const hash = await hashEmail(rawEmail);
                    setIdentityCookie(hash);
                    pushToDataLayer(hash, 'shopify_ajax_submission');
                    syncIdentityToBackend(hash, rawEmail, 'shopify_ajax_submission', 'ajax_button');
                }
            }
        }
    });

    // 5. Klaviyo Popup Form Submission Listener
    window.addEventListener("klaviyoForms", async function(e) { 
        if (e.detail.type == 'submit') {
            const rawEmail = e.detail.metaData && e.detail.metaData.$email;
            if (rawEmail) {
                const hash = await hashEmail(rawEmail);
                setIdentityCookie(hash);
                pushToDataLayer(hash, 'shopify_klaviyo_popup');
                syncIdentityToBackend(hash, rawEmail, 'klaviyo_popup', e.detail.formId || 'klaviyo_popup');
            }
        }
    });
}

// Safe Execution Wrapper
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFSTracker);
} else {
    initFSTracker();
}